import { render } from "./multi-store-options.vue?vue&type=template&id=2f06942e"
import script from "./multi-store-options.vue?vue&type=script&lang=js"
export * from "./multi-store-options.vue?vue&type=script&lang=js"

import "./multi-store-options.vue?vue&type=style&index=0&id=2f06942e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__